import React from 'react';
import TublyLogo from './TublyLogo';

const Footer: React.FC = () => (
  <footer className="bg-gray-50 border-t border-gray-200">
    <div className="container mx-auto px-6 py-8">
      <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
        <div className="flex items-center gap-3">
          <TublyLogo className="w-8 h-auto" />
          <h1 className="text-xl font-bold text-gray-900">tubly</h1>
        </div>
        <div className="flex gap-4 mt-4 md:mt-0 text-sm text-gray-500">
          <a href="/privacy" className="hover:text-gray-800">Privacy Policy</a>
          <a href="/terms" className="hover:text-gray-800">Terms of Service</a>
        </div>
      </div>
      <p className="text-center text-xs text-gray-400 mt-6">&copy; {new Date().getFullYear()} Tubly. All rights reserved.</p>
    </div>
  </footer>
);

export default Footer;

